import { render, staticRenderFns } from "./SourceLabel.vue?vue&type=template&id=500e0b35&scoped=true"
import script from "./SourceLabel.vue?vue&type=script&lang=js"
export * from "./SourceLabel.vue?vue&type=script&lang=js"
import style0 from "./SourceLabel.vue?vue&type=style&index=0&id=500e0b35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500e0b35",
  null
  
)

export default component.exports